"use client";

import dynamic from "next/dynamic";

const SaasSectionClient = dynamic(
  () => import("@/components/sections/saas-sections").then((mod) => mod.SaasSection),
  {
    loading: () => null,
  }
);

export function SaasSectionLoader({
  sectionKey,
  content,
}: {
  sectionKey: string;
  content: Record<string, unknown>;
}) {
  return <SaasSectionClient sectionKey={sectionKey} content={content} />;
}
